"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterplanetaryColonyShip = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var BuildColony_1 = require("../../deferredActions/BuildColony");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var InterplanetaryColonyShip = (function (_super) {
    __extends(InterplanetaryColonyShip, _super);
    function InterplanetaryColonyShip() {
        return _super.call(this, {
            cost: 12,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.EARTH],
            name: CardName_1.CardName.INTERPLANETARY_COLONY_SHIP,
            cardType: CardType_1.CardType.EVENT,
            metadata: {
                cardNumber: 'C17',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.colonies(1); }),
                description: 'Place a colony.',
            },
        }) || this;
    }
    InterplanetaryColonyShip.prototype.canPlay = function (player) {
        return player.hasAvailableColonyTileToBuildOn();
    };
    InterplanetaryColonyShip.prototype.play = function (player) {
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony for Interplanetary Colony Ship'));
        return undefined;
    };
    return InterplanetaryColonyShip;
}(Card_1.Card));
exports.InterplanetaryColonyShip = InterplanetaryColonyShip;
//# sourceMappingURL=InterplanetaryColonyShip.js.map